import { BarChartElem } from "componentsNew/charts/BarChartTemp";
import { FC } from "react";

interface ShiftGraphProps {
  data: any;
  margin: any;
  height: number;
  hideLegend?: boolean;
}

export const ShiftGraph: FC<ShiftGraphProps> = ({ data, margin, height }) => {
  return (
    <BarChartElem
      dataset={data}
      xAxis={[
        { position: undefined, tickMinStep: 1, valueFormatter: (value: any) => value.toFixed(0) },
      ]}
      yAxis={[{ scaleType: "band", dataKey: "name" }]}
      series={[
        {
          type: "bar",
          dataKey: "count",
          label: "",
          valueFormatter: (value: number | null) => value,
          color: "#0129FA",
        },
      ]}
      margin={margin}
      height={height}
      layout={"horizontal"}
    />
  );
};
